module.exports = __webpack_public_path__ + "img/pic3.fad9d431.jpg";